import React, { useRef, useState } from "react"
import { Animated, View, StyleSheet, Easing, Platform } from "react-native"
import { useTheme } from "styled-rn"

import { PuzmoLoadingFaceOnly } from "../svgAnimations/PuzmoLoadingFaceOnly"
import { PuzmoLoadingFaceOnlySinging } from "../svgAnimations/PuzmoLoadingFaceOnlySinging"
import { WhistleNotes } from "../svgAnimations/WhistleNotes"
import { useViewport } from "../../lib/useViewport"

export const MainSiteLoaderSmiley = () => {
  const theme = useTheme()
  const widthVal = useState(new Animated.Value(0))[0]
  const [singing, setSinging] = useState(false)
  const mounted = useRef(false)
  const width = widthVal.interpolate({
    inputRange: [0, 1],
    outputRange: ["11%", "100%"],
    extrapolate: "clamp",
  })

  const scaleVal = useState(new Animated.Value(0))[0]
  const scaleX = scaleVal.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: [1, 1.125, 1],
  })

  const scaleY = scaleVal.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: [1, 1.05, 1],
  })

  if (!mounted.current) {
    mounted.current = true
    Animated.timing(widthVal, {
      isInteraction: false,
      toValue: 1,
      duration: 1550,
      delay: 250,
      useNativeDriver: true,
      // https://cubic-bezier.com/#.6,.5,.9,1
      easing: Easing.bezier(0.6, 0.5, 0.9, 1),
    }).start(({ finished }) => {
      if (finished) {
        Animated.spring(scaleVal, {
          isInteraction: false,
          toValue: 1,
          useNativeDriver: true,
          speed: 6,
          bounciness: 3,
        }).start()

        setTimeout(() => {
          setSinging(true)
        }, 500)
      }
    })
  }

  const { vh } = useViewport()

  return (
    <View
      style={{
        height: vh(100) - 180,
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <View style={{ backgroundColor: theme.g_bgDark, width: 268, height: 22, borderRadius: 84 / 2 }}>
        <Animated.View
          style={[
            StyleSheet.absoluteFill,
            {
              transform: [
                {
                  scaleX,
                  scaleY,
                },
              ],
              backgroundColor: theme.a_puzmo,
              width,
              borderRadius: 84 / 2,
            },
          ]}
        >
          <View style={{ position: "absolute", right: -10, top: -14 }}>
            {singing ? <PuzmoLoadingFaceOnlySinging width={50} /> : <PuzmoLoadingFaceOnly width={50} />}
            {singing && (
              <View
                style={{
                  position: "absolute",
                  top: -20,
                  right: -10,
                }}
              >
                <WhistleNotes width={50} />
              </View>
            )}
          </View>
        </Animated.View>
      </View>
    </View>
  )
}
